var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card" }, [
      _c("div", {}, [
        _c("img", {
          staticClass: " img-fluid",
          attrs: {
            src:
              _vm.video.cover === null
                ? "/images/cover.jpg"
                : _vm.video.cover.url,
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-content" }, [
        _c("div", { staticClass: "card-body pb-05" }, [
          _c("h1", {
            staticClass: "font-large-2",
            domProps: { textContent: _vm._s(_vm.video.title) },
          }),
          _vm._v(" "),
          _vm.video.privacy === 1
            ? _c(
                "p",
                {
                  staticClass: "text-bold-600 mb-05",
                  staticStyle: { color: "#d0198b" },
                },
                [
                  _c("i", { staticClass: "feather icon-award" }),
                  _vm._v(" PREMIUM ONLY"),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pt-1 pb-1 border-bottom border-top mt-1" },
            [
              _c("span", {
                staticClass: "breakAll image-resize",
                domProps: { innerHTML: _vm._s(_vm.video.description) },
              }),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "pt-1" }, [
              _c(
                "a",
                {
                  staticClass:
                    "download-button btn btn-primary waves-effect waves-light form-control",
                  staticStyle: { border: "none" },
                  attrs: {
                    href: "#",
                    "data-toggle": "modal",
                    "data-target": "#registerModal",
                  },
                },
                [
                  _c("i", { staticClass: "feather icon-eye" }),
                  _vm._v(" " + _vm._s(_vm.__("video.watch_now")) + " "),
                ]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "p-2",
                staticStyle: { display: "none" },
                attrs: { id: "progress" },
              }),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-between border-top pl-05 pr-05",
        },
        [
          _c("div", { staticClass: "p-05" }, [
            _c("i", {
              staticClass: "fa fa-thumbs-o-up",
              attrs: {
                "data-toggle": "modal",
                "data-target": "#registerModal",
              },
            }),
            _vm._v(
              "\n                 " +
                _vm._s(_vm.video.likes === 0 ? "" : _vm.video.likes) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "p-05" }, [
            _c(
              "span",
              {
                staticClass: "comment-button",
                attrs: {
                  "data-toggle": "modal",
                  "data-target": "#registerModal",
                },
              },
              [
                _c("i", { staticClass: "fa fa-comment-o" }),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.video.comments === 0 ? "" : _vm.video.comments) +
                    "\n                    " +
                    _vm._s(
                      _vm.video.comments === 1
                        ? _vm.__("globals.comment")
                        : _vm.__("globals.comments")
                    ) +
                    "\n                "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [_c("guest-social-share", { attrs: { social: _vm.video.social } })],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }